// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"PortalLoading_loadingWrapper__2wyvC","loadingContent":"PortalLoading_loadingContent__NVTia"};